export * from "-!../node_modules/_vue-loader@15.9.1@vue-loader/lib/loaders/templateLoader.js??vue-loader-options!../node_modules/_vue-loader@15.9.1@vue-loader/lib/index.js??vue-loader-options!./App.vue?vue&type=template&id=79a250cc&"


//////////////////
// WEBPACK FOOTER
// ./src/App.vue?vue&type=template&id=79a250cc&
// module id = 24
// module chunks = 0